import 'PublicPath';

import renderReact from 'utils/renderReact';

import App from './App';
import createStore from './redux/main';

export default renderReact('main', App, createStore);
